<template>
    <div class="row section border">
        <div class="col s12">
            <div id="recover-password-form" class="col s10 offset-s1" novalidate>
                <div class="row">
                    <div class="input-field">
                        <eg-input
                            v-model.trim="email"
                            title="E-mail"
                            :value="email"
                            :rules="rules"
                            :valid="valid"
                            @valid="rules.valid = $event"
                        />
                    </div>
                </div>

                <eg-button
                    class="btn light-blue darken-4 right col xl3 l3 m3 s12"
                    @click="validateInput"
                    :loading="loading"
                    :disabled="!rules.valid || send"
                >
                    Recuperar senha
                </eg-button>
            </div>
        </div>
    </div>
</template>

<script>
import { recoverPassword } from '@/services';
import { mapActions } from 'vuex';
export default {
    data: () => ({
        email: '',
        loading: false,
        valid: true,
        send: false,
        rules: {
            required: true,
            type: 'email',
            name: 'E-mail',
            valid: true
        }
    }),
    methods: {
        ...mapActions('notification', ['showNotification']),
        async validateInput() {
            this.loading = true;
            this.valid = !this.valid;
            await setTimeout(() => {}, 500);
            if (this.rules.valid) {
                await this.recoverPassword();
            }
            this.loading = false;
        },
        async recoverPassword() {
            const formData = {
                email: this.email,
                referer: this.$route.query.referer
            };
            const { error } = await recoverPassword(formData);
            if (error) {
                const { message } = JSON.parse(error.request.response)
                this.showNotification({ text: message, type: 'error' });
            } else {
                this.showNotification({
                    text: 'Um e-mail foi enviado com as instruções para a troca de senha',
                    type: 'success'
                });
                this.send = true;
            }
        }
    }
};
</script>

<style>
::v-deep .eg-button {
    margin-top: 20px;
}

.recover-password-success {
    display: none;
}

.row.section {
    margin: 60px auto;
    padding: 40px 0;
}
</style>
